import { render, staticRenderFns } from "./DashboardTvVideo.vue?vue&type=template&id=19331898"
var script = {}
import style0 from "./DashboardTvVideo.vue?vue&type=style&index=0&id=19331898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports